import { createSlice } from '@reduxjs/toolkit';
import { defineState } from 'redux-localstore';

const initialState = defineState([])('history');

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    // payload: { playedAt, scoreA, scoreB, winner, teamA, teamB } (cada time: {name, players[]})
    addMatchToHistory: (state, action) => {
      state.unshift(action.payload); // mais recente primeiro
    },
    clearHistory: () => [],
  },
});

export const {
  addMatchToHistory,
  clearHistory,
} = historySlice.actions;
